import React from "react";

import cn from "classnames";
import { Moment } from "moment";
import { useTranslation } from "react-i18next";

import { ClockCircleFilled, InfoCircleFilled } from "@ant-design/icons";
import { Spin, Tooltip } from "antd";

import styles from "./styles.module.scss";

export interface WidgetProps {
  title: React.ReactNode;
  className?: string;
  icons?: React.ReactNode[];
  lastUpdated?: Moment;
  helpText?: string;
  isLoading?: boolean;
}

export const Widget: React.FC<WidgetProps> = (props) => {
  const { t } = useTranslation("widget");

  return (
    <div className={cn([styles.widget, props.className])}>
      <div className={styles.header}>
        {props.title}
        <div className={styles.icons}>
          {props.icons}
          {props.lastUpdated && (
            <Tooltip title={t("lastUpdate", { lastUpdate: props.lastUpdated.fromNow() })}>
              <ClockCircleFilled />
            </Tooltip>
          )}
          {props.helpText && (
            <Tooltip title={props.helpText}>
              <InfoCircleFilled />
            </Tooltip>
          )}
        </div>
      </div>
      <div className={styles.content}>
        {props.isLoading ? <Spin className={styles.spinner} size="large" /> : props.children}
      </div>
    </div>
  );
};
